import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=667bc9c9&scoped=true"
import script from "./fans.vue?vue&type=script&lang=js"
export * from "./fans.vue?vue&type=script&lang=js"
import style0 from "./fans.vue?vue&type=style&index=0&id=667bc9c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667bc9c9",
  null
  
)

export default component.exports